import React, { useRef, useEffect } from "react";
import { InputNumber, InputNumberChangeEvent } from 'primereact/inputnumber';

interface NumberInputProps {
    inputId: string;
    label: string;
    labelHtmlFor: string;
    placeholder?: string;
    required?: boolean;
    value: number | null;
    onChange: (e: InputNumberChangeEvent) => void;
    error?: string;
    minFractionDigits?: number;
    maxFractionDigits?: number;
    max?: number;
    min?: number;
    prefix?: string;
    suffix?: string;
    formGroupClassName?: string;
    inputClassName?: string;
    inputAutoFocus?: boolean;
    inputDisabled?: boolean;
    inputReadOnly?: boolean;
}
const NumberInput: React.FC<NumberInputProps> = ({
    inputId,
    label,
    labelHtmlFor,
    placeholder,
    required,
    value,
    onChange,
    error,
    minFractionDigits,
    maxFractionDigits,
    max,
    min,
    prefix,
    suffix,
    formGroupClassName,
    inputClassName,
    inputAutoFocus,
    inputDisabled,
    inputReadOnly
}) => {

    const inputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.setAttribute('autocomplete', 'off');
        }
    }, []);

    return (
        <div className={`page_form_group ${formGroupClassName}`}>
            <label htmlFor={labelHtmlFor} className={`custom_form_label ${required ? 'is_required' : ''}`}>{label}</label>

            <InputNumber
                inputId={inputId}
                value={value}
                onChange={onChange}
                className={`custom_form_input w-100 ${inputClassName}`}
                placeholder={placeholder}
                useGrouping={false}
                mode="decimal"
                minFractionDigits={minFractionDigits}
                maxFractionDigits={maxFractionDigits}
                max={max}
                min={min}
                prefix={prefix}
                suffix={suffix}
                inputRef={inputRef}
                autoFocus={inputAutoFocus}
                disabled={inputDisabled}
                readOnly={inputReadOnly}
            />

            {error && <small className="form_error_msg">{error}</small>}
        </div>
    )

}

export default NumberInput;